import { MijnRoute } from '../mijn-navigatie.model';

export const HYPOTHEKEN_DOCUMENTEN_UPLOADEN: MijnRoute = {
    path: 'hypotheken-documenten-uploaden',
    navigationEvent: 'toHypothekenDocumentenUploaden',
    regex: /^\/hypotheken-documenten-uploaden$/,
    webcomponent: 'mijn-hypotheken-documenten-uploaden-webcomponent'
};
